// Modules built but not launched yet. While false they are hidden everywhere
// (menu, routes, settings, plans, notifications). Turn on at build time with
// REACT_APP_ACCOUNTING_ENABLED=true, together with ACCOUNTING_ENABLED=true on the backend.
export const ACCOUNTING_LAUNCHED = process.env.REACT_APP_ACCOUNTING_ENABLED === 'true';

// Features of the accounting module (invoicing, SDI, DDT, proforma, credit notes, purchases)
export const ACCOUNTING_FEATURES = [
  'ddt', 'proforma', 'invoices', 'credit_notes', 'purchases', 'accounting', 'sdi', 'passive_invoices',
];

// Shown in the menu while the module is not launched yet (greyed out, not clickable)
export const ACCOUNTING_COMING_LABEL = 'Disponibile da Gennaio 2027';

export const isLaunched = (feature) => ACCOUNTING_LAUNCHED || !ACCOUNTING_FEATURES.includes(feature);

// Automatic WhatsApp alerts need the official WhatsApp API: hidden until it is set up
export const WHATSAPP_ALERTS_LAUNCHED = process.env.REACT_APP_WHATSAPP_ALERTS_ENABLED === 'true';

// Plans offered while accounting is not launched ('gestionale' is the accounting plan)
export const isPlanOffered = (planId) => ACCOUNTING_LAUNCHED || planId !== 'gestionale';
